export class MoleculePanelServiceObjectMailboxComponent {
    public templateUrl = require('./panel-service-object-mailbox.html?external');
}
